import { __decorate, __extends } from "tslib";
import React from 'react';
import { config } from '../../../config';
import s from './solution-breadcrumbs.scss';
import { Path } from '../../..';
import { biLogger } from '../../../bi';
import { Breadcrumbs } from 'wix-style-react';
import { AppMarketLink } from '../../app-market-link';
import { withTranslation } from '../../../component-decorators/with-translation';
export var dtoToBreadcrumbsSectionProps = function (solutionDto, prevRoute) {
    var props = {
        tags: solutionDto.baseInfo.Tags,
        name: solutionDto.baseInfo.name,
        id: solutionDto.baseInfo.id,
    };
    if (prevRoute && prevRoute.path === Path.CATEGORY) {
        props.prevCategory = prevRoute.slug;
        props.prevSubcategory =
            prevRoute.subCategories && prevRoute.subCategories[0];
    }
    return props;
};
var filterCategoriesByTag = function (tags) {
    if (tags && tags.length) {
        var categories = tags.filter(function (tag) { return tag.type === 'CATEGORY' && !tag.parentSlug && !tag.isHidden; });
        if (categories.length) {
            return categories[0].slug;
        }
    }
};
var filterSubcategoriesByCategory = function (category, tags) {
    if (tags && tags.length) {
        var subcategories = tags.filter(function (tag) {
            return tag.type === 'CATEGORY' && tag.parentSlug === category && !tag.isHidden;
        });
        if (subcategories.length) {
            return subcategories[0].slug;
        }
    }
};
var getTagNameBySlug = function (slug, tags) {
    var requestedTag = tags.find(function (tag) { return tag.slug === slug; });
    return (requestedTag && requestedTag.name) || slug;
};
var SolutionBreadcrumbsSection = /** @class */ (function (_super) {
    __extends(SolutionBreadcrumbsSection, _super);
    function SolutionBreadcrumbsSection(props) {
        var _this = _super.call(this, props) || this;
        _this.getBreadcrumbs = function () {
            if (!_this.state ||
                !_this.state.category ||
                !_this.state.subcategory ||
                _this.props.tags === []) {
                return [];
            }
            var itemsValue = [
                _this.props.t('breadcrumbs.home'),
                getTagNameBySlug(_this.state.category, _this.props.tags),
                getTagNameBySlug(_this.state.subcategory, _this.props.tags),
                _this.props.name,
            ];
            return itemsValue.map(function (value, id) {
                return {
                    id: id,
                    value: value,
                    customElement: (React.createElement(AppMarketLink, { className: s.breadcrumbLink, to: _this.getHref({ id: id, value: value }) }, value)),
                };
            });
        };
        _this.getItemAction = function (item) {
            var tagName = _this.props.id;
            var tagType = 'solution_page';
            // tslint:disable-next-line: switch-default
            switch (item.id) {
                case 0 /* HOME */: {
                    // tslint:disable-next-line: no-floating-promises
                    biLogger.appMarketBreadcrumbsClick({
                        nav_level: 0 /* HOME */,
                        tag_name: tagName,
                        tag_name_clicked: 'homepage',
                        tag_type: tagType,
                        tag_type_clicked: 'homepage',
                    });
                    config.goto({ path: Path.HOME });
                    break;
                }
                case 1 /* CATEGORY */: {
                    // tslint:disable-next-line: no-floating-promises
                    biLogger.appMarketBreadcrumbsClick({
                        nav_level: 1 /* CATEGORY */,
                        tag_name: tagName,
                        tag_name_clicked: _this.state.category.replace(/-/g, '_'),
                        tag_type: tagType,
                        tag_type_clicked: Path.CATEGORY,
                    });
                    config.goto({ path: Path.CATEGORY, slug: _this.state.category });
                    break;
                }
                case 2 /* SUBCATEGORY */: {
                    // tslint:disable-next-line: no-floating-promises
                    biLogger.appMarketBreadcrumbsClick({
                        nav_level: 2 /* SUBCATEGORY */,
                        tag_name: tagName,
                        tag_name_clicked: _this.state.subcategory.replace(/-/g, '_'),
                        tag_type: tagType,
                        tag_type_clicked: Path.CATEGORY,
                    });
                    config.goto({
                        path: Path.CATEGORY,
                        slug: _this.state.category,
                        subCategories: [_this.state.subcategory],
                    });
                }
            }
        };
        _this.getHref = function (item) {
            var _a;
            var hrefMap = (_a = {},
                _a[0 /* HOME */] = '',
                _a[1 /* CATEGORY */] = Path.CATEGORY + "/" + _this.state.category,
                _a[2 /* SUBCATEGORY */] = Path.CATEGORY + "/" + _this.state.category + "/" + _this.state.subcategory,
                _a);
            return item.value.toLowerCase() === 'home'
                ? ''
                : hrefMap[item.id] || item.value.toLowerCase();
        };
        if (_this.props.tags && _this.props.tags.length) {
            var category = _this.props.prevCategory
                ? _this.props.prevCategory
                : filterCategoriesByTag(_this.props.tags);
            var subcategory = _this.props.prevSubcategory
                ? _this.props.prevSubcategory
                : filterSubcategoriesByCategory(category, _this.props.tags);
            _this.state = { category: category, subcategory: subcategory };
        }
        return _this;
    }
    SolutionBreadcrumbsSection.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.id !== prevProps.id) {
            var category = filterCategoriesByTag(this.props.tags);
            var subcategory = filterSubcategoriesByCategory(category, this.props.tags);
            this.setState({ category: category, subcategory: subcategory });
        }
    };
    SolutionBreadcrumbsSection.prototype.render = function () {
        var _this = this;
        var items = this.getBreadcrumbs();
        return items ? (React.createElement("div", { className: s.breadcrumbsContainer },
            React.createElement(Breadcrumbs, { dataHook: "solution-breadcrumbs-section", items: items, theme: "onWhiteBackground", onClick: function (item) { return _this.getItemAction(item); }, activeId: 3 }))) : (React.createElement("div", null));
    };
    SolutionBreadcrumbsSection = __decorate([
        withTranslation
    ], SolutionBreadcrumbsSection);
    return SolutionBreadcrumbsSection;
}(React.Component));
export { SolutionBreadcrumbsSection };
//# sourceMappingURL=solution-breadcrumbs-section.js.map